// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  
  production: false,
  VERSION: require('../../package.json').version,
  VersionCheckUrl: 'version.json',
  SalesReviewRemoteServer: 'https://salesreviewctd.agris.com/microservice/api', 
  //SalesReviewRemoteServer: 'http://localhost:6241/Microservice/api',
  ConfigurationRemoteServer:'https://configfarmctd.greenstonesystems.com/api', 
  StagingRemoteServer:'https://actionlistctd.greenstonesystems.com/actionlistreview/api', 
  GetwayRemoteServer:'https://gatewayctd.greenstonesystems.com/', 
  EsignRemoteServer: 'https://esignature.greenstonesystems.com/', 
  BookingClient_ID:'SiLNBPkMSxzxPczZ8KF6IsJyYDRnmRDN',
  BookingClient_Sceret:'UVlYQlTqBBVVaTEUXfvHavYr1ZK40WiGnpYmT16qz0aLHNKDjkmhHwoUAecLCL4A',
  BookingClient_Audience:'https://salesreviewctd.agris.com/Microservice/Api/',
  ActionListClient_Audience:'https://actionlist.greenstonesystems.com',
  EsignClient_Audience:'https://esignature.greenstonesystems.com/'

};
